import calls from '@/backend/api-calls'

const state = () => ({
  installationProjects: [],
  selected: [],
  allSelected: false,
  loading: true,
  pagination: {
    page: 1,
    pages: 1
  },
  filters: {
    project_id: null,
    defected_pieces: null
  }
})

// getters
const getters = {
  ids: state => {
    return state.installationProjects.map(d => d.id);
  }
}

// actions
const actions = {
  getInstallationProjects: ({commit}, parameters) => {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      calls.installationSummary.get(parameters)
        .then(resp => {
          commit("setInstallationProjects", resp.data);
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  }
}

// mutations
const mutations = {
  setLoading (state, status) {
    state.loading = status;
  },
  setInstallationProjects (state, data) {
    state.installationProjects = data.results;
    state.pagination = data.pagination;
  },
  changePage(state, page) {
    state.pagination.page = page;
  },
  setFilter(state, { field, value }) {
    state.filters[field] = value;
  },
  selectAll(state, ids) {
    state.allSelected = true;
    ids.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}